import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import {
  deleteReq,
  patch,
  useGet,
  usePatch,
  usePost,
} from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateMembership = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/${activeStore}/membership/create-membership`);
};

export const useGetMemberships = ({
  length,
  page,
  search,
}: {
  length?: number;
  page?: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  let queryData = {};
  if (page && length) {
    const offset = page === 1 ? 0 : (page - 1) * length;
    queryData = { length, offset, search };
  }

  const data = useGet(
    `/users/${activeStore}/membership/list${getQueryData(queryData)}`
  );
  return data;
};

export const useGetMembershipData = (membershipId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    membershipId ? `/users/${activeStore}/membership/${membershipId}` : null
  );
};

export const useUpdateMembership = (membershipId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/${activeStore}/membership/${membershipId}`);
};

export const useDeleteMembership = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (membershipId: number) => {
      return deleteReq(`/users/${activeStore}/membership/${membershipId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};

export const useUpdateMembershipeStatus = () => {
  const activeStore = useSelector(getActiveStoreId);
  const handleStatusChange = useCallback(
    (membershipId: number, status: boolean) => {
      return patch(`/users/${activeStore}/membership/${membershipId}/status`, {
        status,
      });
    },
    [activeStore]
  );
  return useFetchAsync(handleStatusChange);
};
